export class Garage{
    
    
    id: number;
	name: string;
    addres: string;
	city: string;
	urlLayout;
	wipEquivalence;
}